import Occasion from "../models/Occasion";
export default class OccasionService {
    mapInterfaceToModel(input, repositories) {
        let occasion = new Occasion();
        occasion.id = parseInt(input.id);
        occasion.day = input.day;
        occasion.classroom = this.classroomFormat(input.classroom);
        occasion.weeks = input.weeks;
        occasion.startBlock = input.start_block;
        occasion.endBlock = input.end_block;
        occasion.course = repositories[0].get(input.course_id);
        occasion.weekArray = this.formatWeeksArray(occasion.weeks);
        return occasion;
    }
    formatWeeksArray(input) {
        let weekArray = [];
        for (let i = 0; i < input.length; i++) {
            if (input[i] === '1') {
                weekArray.push(i + 1);
            }
        }
        return weekArray;
    }
    classroomFormat(input) {
        return input === 'VNem kell terem' ? 'Nem kell terem' : input;
    }
}
